import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, message } from 'ui';
import type { ExtendedReminderInvitationsFormValues } from '../ReminderInvitationsFormContent';
import type { InvitationSearchOption } from '../types';

type P = {
  invitationCount: number;
  invitationLimit: number;
  invitations: InvitationSearchOption[];
};

export const useOnInvatiotionSelect = ({ invitationCount, invitationLimit, invitations }: P) => {
  const form = Form.useFormInstance<ExtendedReminderInvitationsFormValues>();
  const { t } = useTranslation();

  return useCallback(
    (option: InvitationSearchOption) => {
      const optionPeopleCount = option.type === 'community' ? option.membersCount : 1;
      const totalCount = invitationCount + optionPeopleCount;

      if (totalCount > invitationLimit) {
        if (option.type === 'community') {
          message.error(
            t(
              'Can not add {{communityName}} community ({{membersCount}} members). Only {{remainingSpots}} of {{limit}} spots left.',
              {
                communityName: option.label,
                limit: invitationLimit,
                membersCount: option.membersCount,
                remainingSpots: invitationLimit - invitationCount,
              },
            ),
          );
        } else {
          message.error(
            t('You reached the limit of {{limit}} people. Remove some people, if you want to add new ones.', {
              limit: invitationLimit,
            }),
          );
        }
        return;
      }

      form.setFieldValue('invitations', [...invitations, option]);
    },
    [form, invitationCount, invitationLimit, invitations, t],
  );
};
